import { render, staticRenderFns } from "./yhys.vue?vue&type=template&id=64ec48ef&scoped=true"
import script from "./yhys.vue?vue&type=script&lang=js"
export * from "./yhys.vue?vue&type=script&lang=js"
import style0 from "./yhys.vue?vue&type=style&index=0&id=64ec48ef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ec48ef",
  null
  
)

export default component.exports